import {
  CreateDestinationDTO,
  ECompressionType,
  EDestinationType,
  UpdateDestinationDTO,
} from '_/types/destinations/destinations.types';

import { IDestinationForm } from './DestinationForms.types';

const zipCheck = new RegExp('^(.*?)(zip)?$', 'i');

const zipNotAllowedCheck = new RegExp('^((parquet)|(customparquet)|(files))$', 'i');

const isZipAllowed = (option) => !zipNotAllowedCheck.test(option);

const matchZip = (option) => option.match(zipCheck);

const isZip = (regResult) => regResult[2];

const originalOption = (regResult) => regResult[0];

const zipOption = (regResult) => `${regResult[1]}Zip`;

const unZipOption = (regResult) => regResult[1];

function setFileTypes(files, compression, type) {
  const fileTypes = Object.keys(files) || [];
  delete files.archive;
  if (compression === ECompressionType.ZIP) {
    delete files.noCompression;
    fileTypes.forEach((type) => {
      let matched;
      if (files[type] && isZipAllowed(type) && !isZip((matched = matchZip(type)))) {
        files[unZipOption(matched)] = false;
        files[zipOption(matched)] = true;
      }
    });
  } else {
    if (compression === ECompressionType.NONE) {
      files.noCompression = true;
    } else {
      delete files.noCompression;
    }
    fileTypes.forEach((type) => {
      const matched = matchZip(type);
      files[unZipOption(matched)] = files[originalOption(matched)];
      // Since support for "zip" over "gzip" is a bit of a hack,
      // remove the hack altogether when using "gzip".
      if (isZip(matched)) delete files[originalOption(matched)];
    });
  }
  return type === 'archive' ? { archive: files } : files;
}

export const createDestinationAdapter = (form: IDestinationForm): CreateDestinationDTO => {
  const { active, compressionType, configuration, encryptedConfig, files, fileType, name, type } = form;
  const newFiles = setFileTypes(files, compressionType, fileType);
  return {
    active: active,
    configuration: configuration as Record<string, string>,
    encryptedConfig: encryptedConfig as Record<string, string>,
    files: newFiles,
    name: name,
    type: type as EDestinationType,
  };
};

export const updateDestinationAdapter = (form: IDestinationForm): UpdateDestinationDTO => {
  const { active, compressionType, configuration, encryptedConfig, files, fileType, name } = form;
  const newFiles = setFileTypes(files, compressionType, fileType);
  const encryptedConfigChanged = Object.values(encryptedConfig).some((value) => value.trim().length > 0);
  return {
    active: active,
    configuration: configuration as Record<string, string>,
    ...(encryptedConfigChanged ? { encryptedConfig: encryptedConfig as Record<string, string> } : undefined),
    files: newFiles,
    name: name,
  };
};
